import styled from "styled-components";

const FormContainer = styled("div")`
    background-color: #fff;
    height: 75%;
    min-height: 650px;
`;

export default FormContainer;
